import Image from "next/image";
import Link from "next/link";
import { ExternalLink } from "lucide-react";

const DISCOVERY_LINKS = [
  { name: "Certified Websites", href: "/certified-websites" },
  { name: "Guides", href: "/guides" },
  { name: "Free Tools", href: "/tools" },
];

export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12">
          <div className="flex flex-col lg:flex-row justify-between items-start space-y-8 lg:space-y-0">
            {/* Left: Logo and Description */}
            <div className="flex flex-col space-y-4 max-w-md">
              <Link
                href="/"
                aria-label="YourWebsiteScore home"
                className="flex items-center space-x-2"
              >
                <Image
                  src="/logo.svg"
                  alt=""
                  aria-hidden
                  width={28}
                  height={28}
                  className="h-7 w-7"
                />
                <span className="font-semibold text-lg">
                  YourWebsiteScore.com
                </span>
              </Link>
              <p className="text-sm text-muted-foreground leading-relaxed">
                YourWebsiteScore analyzes your site, highlights what to fix, and
                gives you a live badge, certified page, and dofollow backlink to
                prove trust.
              </p>
              <p className="text-xs text-muted-foreground">
                © {new Date().getFullYear()} YourWebsiteScore. All rights
                reserved.
              </p>

              {/* Twitter Card */}
              <a
                href="https://twitter.com/andi_losing"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center space-x-3 px-4 py-3 rounded-xl bg-card/50 hover:bg-card/80 border border-border/30 hover:border-border/60 transition-all duration-300 w-fit"
              >
                <Image
                  src="/images/andi-avatar.jpeg"
                  alt="Andi"
                  width={128}
                  height={128}
                  quality={100}
                  loading="lazy"
                  className="h-8 w-8 rounded-full object-cover ring-2 ring-primary/20 group-hover:ring-primary/40 transition-all duration-300"
                />

                <div className="flex flex-col space-y-1">
                  <div className="flex items-center space-x-2">
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="h-4 w-4 text-muted-foreground group-hover:text-foreground transition-colors"
                    >
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                    <span className="font-medium text-sm group-hover:text-foreground transition-colors">
                      @andi_losing
                    </span>
                  </div>
                  <div className="flex items-center space-x-1 text-xs text-muted-foreground group-hover:text-foreground/80 transition-colors">
                    <span>Made with</span>
                    <span className="text-blue-500">💙</span>
                    <span>by Andi</span>
                  </div>
                </div>
              </a>
            </div>

            {/* Middle: Explore */}
            <div className="text-sm">
              <p className="font-medium text-foreground">Explore</p>
              <ul className="mt-3 space-y-2">
                {DISCOVERY_LINKS.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-muted-foreground hover:underline hover:underline-offset-4"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
                {/* FeatureMessage - auskommentiert */}
                {/* <li>
                  <a
                    href="https://featuremessage.com?ref=yourwebsitescore"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 text-muted-foreground hover:underline hover:underline-offset-4"
                  >
                    <Image
                      src="/logos/featured-ads/featureme.svg"
                      alt="FeatureMessage logo"
                      width={16}
                      height={16}
                      className="h-4 w-4"
                    />
                    <span>FeatureMessage</span>
                    <ExternalLink className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                  </a>
                </li> */}
              </ul>
            </div>

            {/* Right: Legal Links */}
            <div className="flex flex-col space-y-2 text-sm">
              <p className="font-medium text-foreground">Legals</p>
              <Link
                href="/privacy"
                className="text-muted-foreground hover:underline hover:underline-offset-4"
              >
                Privacy Policy
              </Link>
              <Link
                href="/imprint"
                className="text-muted-foreground hover:underline hover:underline-offset-4"
              >
                Imprint
              </Link>
              <Link
                href="/tos"
                className="text-muted-foreground hover:underline hover:underline-offset-4"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
